"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DettaglioCertificazioneDtoToJSON = exports.DettaglioCertificazioneDtoFromJSONTyped = exports.DettaglioCertificazioneDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function DettaglioCertificazioneDtoFromJSON(json) {
    return DettaglioCertificazioneDtoFromJSONTyped(json, false);
}
exports.DettaglioCertificazioneDtoFromJSON = DettaglioCertificazioneDtoFromJSON;
function DettaglioCertificazioneDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'certificazione': !runtime_1.exists(json, 'certificazione') ? undefined : _1.CertificazioneExtendedDtoFromJSON(json['certificazione']),
        'certificazioniEmail': !runtime_1.exists(json, 'certificazioniEmail') ? undefined : (json['certificazioniEmail'] === null ? null : json['certificazioniEmail'].map(_1.CertificazioneEmailDtoFromJSON)),
    };
}
exports.DettaglioCertificazioneDtoFromJSONTyped = DettaglioCertificazioneDtoFromJSONTyped;
function DettaglioCertificazioneDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'certificazione': _1.CertificazioneExtendedDtoToJSON(value.certificazione),
        'certificazioniEmail': value.certificazioniEmail === undefined ? undefined : (value.certificazioniEmail === null ? null : value.certificazioniEmail.map(_1.CertificazioneEmailDtoToJSON)),
    };
}
exports.DettaglioCertificazioneDtoToJSON = DettaglioCertificazioneDtoToJSON;
